import { AgentsActionTypes } from './constants';
import { PAGINATION_DEFAULT_VALUE } from '../../helpers/defaultValue';

const INIT_STATE = {
    loadingAgents: false,
    agents: [],
    pagination: PAGINATION_DEFAULT_VALUE,
    creatingAgent: false,
    updatingAgentId: null,
    deletingAgentId: null,
    error: null,
};

const Agents = (state = INIT_STATE, action) => {
    switch (action.type) {
        case AgentsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case AgentsActionTypes.READ_AGENTS_REQUEST:
                    return {
                        ...state,
                        loadingAgents: false,
                        agents: action.payload.data.agents || [],
                        pagination: { ...PAGINATION_DEFAULT_VALUE, ...action.payload.data.pagination },
                        error: null,
                    };
                case AgentsActionTypes.CREATE_AGENT_REQUEST:
                    return { ...state, creatingAgent: false, error: null };
                case AgentsActionTypes.UPDATE_AGENT_REQUEST:
                    return { ...state, updatingAgentId: null, error: null };
                case AgentsActionTypes.DELETE_AGENT_REQUEST:
                    return { ...state, deletingAgentId: null, error: null };
                default:
                    return state;
            }
        case AgentsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case AgentsActionTypes.READ_AGENTS_REQUEST:
                    return { ...state, loadingAgents: false, error: action.payload.error };
                case AgentsActionTypes.CREATE_AGENT_REQUEST:
                    return { ...state, creatingAgent: false, error: action.payload.error };
                case AgentsActionTypes.UPDATE_AGENT_REQUEST:
                    return { ...state, updatingAgentId: null, error: action.payload.error };
                case AgentsActionTypes.DELETE_AGENT_REQUEST:
                    return { ...state, deletingAgentId: null, error: action.payload.error };
                default:
                    return state;
            }
        case AgentsActionTypes.READ_AGENTS_REQUEST:
            return { ...state, loadingAgents: true };
        case AgentsActionTypes.CREATE_AGENT_REQUEST:
            return { ...state, creatingAgent: true };
        case AgentsActionTypes.UPDATE_AGENT_REQUEST:
            return { ...state, updatingAgentId: action.payload.agentId };
        case AgentsActionTypes.DELETE_AGENT_REQUEST:
            return { ...state, deletingAgentId: action.payload.agentId };
        case AgentsActionTypes.RESET_AGENT_STATE:
            return INIT_STATE;
        default:
            return state;
    }
};

export default Agents;
